/**
 * Google Workspace API deprovision reasons
 * See https://developers.google.com/workspace/admin/directory/reference/rest/v1/chromeosdevices#DeprovisionReason
 */
export enum DeprovisionReason {
  UNSPECIFIED = 'DEPROVISION_REASON_UNSPECIFIED',
  SAME_MODEL_REPLACEMENT = 'DEPROVISION_REASON_SAME_MODEL_REPLACEMENT',
  DIFFERENT_MODEL_REPLACEMENT = 'DEPROVISION_REASON_DIFFERENT_MODEL_REPLACEMENT',
  UPGRADE = 'DEPROVISION_REASON_UPGRADE',
  DOMAIN_MOVE = 'DEPROVISION_REASON_DOMAIN_MOVE',
  SERVICE_EXPIRATION = 'DEPROVISION_REASON_SERVICE_EXPIRATION',
  OTHER = 'DEPROVISION_REASON_OTHER',
  RETIRING_DEVICE = 'DEPROVISION_REASON_RETIRING_DEVICE',
  UPGRADE_TRANSFER = 'DEPROVISION_REASON_UPGRADE_TRANSFER',
  NOT_REQUIRED = 'DEPROVISION_REASON_NOT_REQUIRED',
  REPAIR_CENTER = 'DEPROVISION_REASON_REPAIR_CENTER',
}

/**
 * User-friendly labels for deprovision reasons
 */
export const DEPROVISION_REASON_LABELS: Record<DeprovisionReason, string> = {
  [DeprovisionReason.UNSPECIFIED]: 'Unspecified',
  [DeprovisionReason.SAME_MODEL_REPLACEMENT]:
    'Same model replacement (e.g. Acer C720 is malfunctioning and will be replaced by the same model or RMA equipment)',
  [DeprovisionReason.DIFFERENT_MODEL_REPLACEMENT]:
    'Different model replacement (e.g. upgrading an Acer C720 with a Samsung Pro)',
  [DeprovisionReason.UPGRADE]: 'Upgrade',
  [DeprovisionReason.DOMAIN_MOVE]: 'Domain move',
  [DeprovisionReason.SERVICE_EXPIRATION]: 'Service expiration',
  [DeprovisionReason.OTHER]: 'Other',
  [DeprovisionReason.RETIRING_DEVICE]: 'Retiring device (e.g. donating, selling, recycling)',
  [DeprovisionReason.UPGRADE_TRANSFER]: 'Replacing CloudReady devices with Chromebooks within a year',
  [DeprovisionReason.NOT_REQUIRED]:
    'A reason is not required (e.g. the licenses are returned to the license pool)',
  [DeprovisionReason.REPAIR_CENTER]: 'Repair center',
};

/**
 * Common deprovision reasons to display in UI
 */
export const COMMON_DEPROVISION_REASONS = [
  {
    value: DeprovisionReason.SAME_MODEL_REPLACEMENT,
    label: DEPROVISION_REASON_LABELS[DeprovisionReason.SAME_MODEL_REPLACEMENT],
  },
  {
    value: DeprovisionReason.DIFFERENT_MODEL_REPLACEMENT,
    label: DEPROVISION_REASON_LABELS[DeprovisionReason.DIFFERENT_MODEL_REPLACEMENT],
  },
  {
    value: DeprovisionReason.RETIRING_DEVICE,
    label: DEPROVISION_REASON_LABELS[DeprovisionReason.RETIRING_DEVICE],
  },
  {
    value: DeprovisionReason.UPGRADE_TRANSFER,
    label: DEPROVISION_REASON_LABELS[DeprovisionReason.UPGRADE_TRANSFER],
  },
  {
    value: DeprovisionReason.NOT_REQUIRED,
    label: DEPROVISION_REASON_LABELS[DeprovisionReason.NOT_REQUIRED],
  },
];
